<div class="flex flex-col p-6 gap-8">
  <!-- Sidebar Header -->
  @if (isSidebarMode) {
    <div class="flex items-center justify-between">
      <h1>{{ group?.name || 'Group' }}</h1>
      <ep-button type="quiet" (click)="closeSidebar()">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </ep-button>
    </div>
  } @else {
    <!-- Breadcrumbs for standalone mode -->
    <ep-breadcrumbs>
      <ep-breadcrumb [routerLink]="['/']"><span>Realm</span></ep-breadcrumb>
      <ep-breadcrumb [routerLink]="['/groups']"><span>Groups</span></ep-breadcrumb>
      <ep-breadcrumb
        ><span>{{ group?.name || 'Group' }}</span></ep-breadcrumb
      >
    </ep-breadcrumbs>

    <div class="flex justify-between items-center">
      <h1>{{ group?.name || 'Group' }}</h1>
    </div>
  }

  @if (isLoading) {
    <div class="text-center py-8">Loading group details...</div>
  } @else {
    @if (successMessage) {
      <ep-alert type="toast" variant="alt" color="success" [center]="true" [bottom]="true">
        <span slot="header">{{ successMessage }}</span>
      </ep-alert>
    }
    @if (errorMessage) {
      <ep-alert type="toast" variant="alt" color="danger" [center]="true" [bottom]="true">
        <span slot="header">{{ errorMessage }}</span>
      </ep-alert>
    }

    <ep-tab-container [activeTab]="activeTab" (tab-change)="setActiveTab($event)">
      <ep-tab value="details"><span>Details</span></ep-tab>
      <ep-tab value="members"><span>Members</span></ep-tab>
      <ep-tab value="roles"><span>Role Mappings</span></ep-tab>
    </ep-tab-container>

    <!-- Details Tab -->
    @if (activeTab === 'details') {
      <form [formGroup]="groupForm" class="flex flex-col gap-5">
        <!--        <ep-textfield
                  label="Group Name"
                  formControlName="name"
                  ngDefaultControl
                >
                  @if (groupForm.get('name')?.invalid && groupForm.get('name')?.touched) {
                    <div slot="error">Group name is required</div>
                  }
                </ep-textfield>-->

        <div class="flex flex-col">
          <label>Group name</label>
          <span>{{ group?.name }}</span>
        </div>

        <div class="flex flex-col">
          <label>Group path</label>
          <span>{{ group?.path }}</span>
        </div>
      </form>
    }

    <!-- Members Tab -->
    @if (activeTab === 'members') {
      <div class="flex flex-col gap-5">
        @if (isLoadingMembers) {
          <div class="text-center py-4">Loading members...</div>
        } @else {
          <div class="grid grid-cols-2 gap-6">
            <!-- Available users -->
            <div class="flex flex-col gap-3">
              <h3>Available Users</h3>
              <ep-textfield
                placeholder="Search users..."
                (input)="onMemberSearchChange($event)"
              ></ep-textfield>
              @if (filteredAvailableUsers.length === 0) {
                <div class="text-center py-4 text-gray-500">No available users</div>
              } @else {
                <div class="overflow-y-auto max-h-80">
                  @for (user of filteredAvailableUsers; track user.id) {
                    <ep-item>
                      <span slot="text">{{ formatDisplayName(user) }}</span>
                      <span slot="subtext">{{ user.email || 'No email' }}</span>
                      <span slot="extra">
                        @if (group?.access?.manageMembership) {
                          <ep-button
                            color="default"
                            size="small"
                            (click)="addMember(user)"
                            [disabled]="isSaving"
                          >
                            <svg class="icon icon--small" viewBox="0 0 24 24" fill="currentColor">
                              <path
                                d="M12 2a10 10 0 0 1 10 10"
                                stroke-width="4"
                                stroke="currentColor"
                              />
                              <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke-width="4"
                                stroke="currentColor"
                                stroke-opacity="0.25"
                              />
                            </svg>
                          </ep-button>
                        }
                      </span>
                    </ep-item>
                  }
                </div>
              }
            </div>

            <!-- Group members -->
            <div class="flex flex-col gap-3">
              <h3>Group Members</h3>
              @if (groupMembers.length === 0) {
                <div class="text-center py-4 text-gray-500">No members in this group</div>
              } @else {
                <div class="overflow-y-auto max-h-80">
                  @for (member of groupMembers; track member.id) {
                    <ep-item>
                      <span slot="text">{{ formatDisplayName(member) }}</span>
                      <span slot="subtext">{{ member.email || 'No email' }}</span>
                      <span slot="extra">
                        @if (group?.access?.manageMembership) {
                          <ep-button
                            color="default"
                            size="small"
                            (click)="removeMember(member)"
                            [disabled]="isSaving"
                          >
                            <svg class="icon icon--small" viewBox="0 0 24 24" fill="currentColor">
                              <path
                                d="M12 2a10 10 0 0 1 10 10"
                                stroke-width="4"
                                stroke="currentColor"
                              />
                              <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke-width="4"
                                stroke="currentColor"
                                stroke-opacity="0.25"
                              />
                            </svg>
                          </ep-button>
                        }
                      </span>
                    </ep-item>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    <!-- Role Mappings Tab -->
    @if (activeTab === 'roles') {
      <div class="flex flex-col gap-5">
        <ep-select
          (ngModelChange)="onClientChange($event)"
          ngDefaultControl
          [ngModel]="selectedClient"
        >
          @for (client of clients; track client.id) {
            <ep-option [value]="client.id" [label]="client.name || client.clientId">
              <span slot="text">{{ client.name || client.clientId }}</span>
            </ep-option>
          }
        </ep-select>

        @if (isLoadingRoles) {
          <div class="text-center py-4">Loading roles...</div>
        }

        @if (!isLoadingRoles && selectedClient) {
          <div class="grid grid-cols-2 gap-6">
            <!-- Available roles -->
            <div class="flex flex-col gap-3">
              <h3>Available Roles</h3>
              @if (availableRoles.length === 0) {
                <div class="text-center py-4 text-gray-500">No available roles</div>
              } @else {
                <div class="overflow-y-auto max-h-80">
                  @for (role of availableRoles; track role.id) {
                    <ep-item>
                      <span slot="text">{{ role.name }}</span>
                      @if (role.description) {
                        <span slot="subtext">{{ role.description }}</span>
                      }
                      <span slot="extra">
                        <ep-button
                          color="default"
                          size="small"
                          (click)="assignRole(role)"
                          [disabled]="loadingRoleIds.has(role.id!)"
                        >
                          @if (loadingRoleIds.has(role.id!)) {
                            <svg
                              class="icon icon--small animate-spin"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                            >
                              <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke-width="4"
                                stroke="currentColor"
                                stroke-opacity="0.25"
                              />
                              <path
                                d="M12 2a10 10 0 0 1 10 10"
                                stroke-width="4"
                                stroke="currentColor"
                              />
                            </svg>
                          } @else {
                            <svg
                              class="icon icon--small"
                              viewBox="0 -960 960 960"
                              fill="currentColor"
                            >
                              <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
                            </svg>
                          }
                        </ep-button>
                      </span>
                    </ep-item>
                  }
                </div>
              }
            </div>

            <!-- Assigned roles -->
            <div class="flex flex-col gap-3">
              <h3>Assigned Roles</h3>
              @if (assignedRoles.length === 0) {
                <div class="text-center py-4 text-gray-500">No roles assigned</div>
              } @else {
                <div class="overflow-y-auto max-h-80">
                  @for (role of assignedRoles; track role.id) {
                    <ep-item>
                      <span slot="text">{{ role.name }}</span>
                      @if (role.description) {
                        <span slot="subtext">{{ role.description }}</span>
                      }
                      <span slot="extra">
                        <ep-button
                          color="default"
                          size="small"
                          (click)="removeRole(role)"
                          [disabled]="loadingRoleIds.has(role.id!)"
                        >
                          @if (loadingRoleIds.has(role.id!)) {
                            <svg
                              class="icon icon--small animate-spin"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                            >
                              <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke-width="4"
                                stroke="currentColor"
                                stroke-opacity="0.25"
                              />
                              <path
                                d="M12 2a10 10 0 0 1 10 10"
                                stroke-width="4"
                                stroke="currentColor"
                              />
                            </svg>
                          } @else {
                            <svg
                              class="icon icon--small"
                              viewBox="0 -960 960 960"
                              fill="currentColor"
                            >
                              <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
                            </svg>
                          }
                        </ep-button>
                      </span>
                    </ep-item>
                  }
                </div>
              }
            </div>
          </div>

          <div class="mt-6">
            <h3>Effective Roles</h3>
            @if (effectiveRoles.length === 0) {
              <div class="text-center py-4 text-gray-500">No effective roles</div>
            } @else {
              <div class="overflow-y-auto max-h-80">
                @for (role of effectiveRoles; track role.id) {
                  <ep-item>
                    <span slot="text">{{ role.name }}</span>
                    @if (role.description) {
                      <span slot="subtext">{{ role.description }}</span>
                    }
                  </ep-item>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  }
</div>
